import * as React from "react";
import Seo from "../../components/seo";
import CaseStudy from "../../components/case-study";
import { Container, Row, Col, Image } from "react-bootstrap";
import { graphql } from "gatsby";
import { getSrc } from "gatsby-plugin-image";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/layout/layout";

import Seatsplanetbgsectionimage from "../../images/portfolio/seatsplanet-bg.jpg";
import Seatsplanetbgsectionabout from "../../images/portfolio/seatsplanet-about-bg.jpg";
import Seatsplanetpostride from "../../images/portfolio/seatsplanet-post-ride.gif";
import Seatsplanetpostridesearch from "../../images/portfolio/seatsplanet-search-ride.gif";
import Seatsplanetpostbookridegif from "../../images/portfolio/seatsplanet-book-rides.gif";

export const Head = ({ data }) => {
  const seoData = data.portfolioJson.seo;
  const socialImg = getSrc(seoData?.socialImage);
  return (
    <Seo
      title={seoData?.title}
      description={seoData?.description}
      ogImage={socialImg}
      twitterImage={socialImg}
    />
  )
}

const SeatsplanettravelappPage = () => {

  const Seatsplanetlogo = '../../images/portfolio/seatsplanet-banner-mobile.png'
  const Seatsplaneticon = '../../images/portfolio/seatsplanet-icon.png'

  const Seatsplanetleft = '../../images/portfolio/seatsplanet-about-left.png'
  const Seatsplanetuser = '../../images/portfolio/seatsplanet-user-exprience.jpg'

  const Seatsplanetscrol4 = '../../images/portfolio/seatsplanet-scroll-4.png'
  const Seatsplanetscrol1 = '../../images/portfolio/seatsplanet-scroll-1.png'
  const Seatsplanetscrol2 = '../../images/portfolio/seatsplanet-scroll-2.png'
  const Seatsplanetscrol3 = '../../images/portfolio/seatsplanet-scroll-3.png'

  const Seatsplanetpostridevector = '../../images/portfolio/search-ride-vector.png'
  const Seatsplanetpostbookride = '../../images/portfolio/book-ride-vector.png'

  const Seatsplanetagenda = '../../images/portfolio/seats-planet-agenda.jpg'
  const Seatsplanetearning = '../../images/portfolio/seats-planet-earning.jpg'

  const Seatsplanetdiver = '../../images/portfolio/seat-planet-travel-health-driver-section.jpg'
  const Seatsplanettechnology = '../../images/portfolio/seatsplanet-technology.png'

  return (
    <>
      <Layout headerClass="navbar-dark">
        <div className="text-white-section">
          <section className="section overflow-hidden" style={{ backgroundImage: `url(${Seatsplanetbgsectionimage})` }}>
            {/* <canvas id="background-canvas" className="nurse-alert-banner-animation" width="1366" height="568"></canvas> */}
            <Container className="py-5 mt-lg-5">
              <Row className="align-items-center text-center g-5">
                <Col lg={6} className="order-lg-2 text-center text-lg-start">
                  <StaticImage loading="lazy" src={Seatsplaneticon} alt="Seatsplaneticon" width={340} height={180} />
                  <div className="mt-3">
                    <h1 className="h3 text-white mb-4 mt-5">
                      Taxi Booking Mobile App
                    </h1>
                    <p className="text-white opacity-75 lead">
                      The Founder came to us for an efficient solution design to solve the problems about the workplace commuting, the escalating cost of cars, and to deal with the ever-rising hassles of public transport. The idea of Seats Planet was generated to solve this problem by providing an active car-pooling service by making it efficient, reliable, and profitable.
                    </p>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="waves-animation">
                    <div className="waves-ripples">
                      <div className="waves-ripple waves-ripple-1"><div></div></div>
                      <div className="waves-ripple waves-ripple-2"><div></div></div>
                      <div className="waves-ripple waves-ripple-3"><div></div></div>
                      <div className="waves-ripple waves-ripple-4"><div></div></div>
                    </div>
                    <StaticImage loading="lazy" src={Seatsplanetlogo} alt="Seatsplanetlogo" width={295} height={610} />
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section" style={{ backgroundImage: `url(${Seatsplanetbgsectionabout})` }}>
            <Container className="py-5 mt-lg-5">
              <Row className="align-items-center text-center g-5">
                <Col lg={6} className="order-lg-2">
                  <div className="my-3">
                    <h2 className="text-white h3 title-border-sm text-center">
                      The challenges
                    </h2>
                  </div>
                  <div className="mt-3 text-left">
                    <p className="text-white">
                      One of the most constructive challenges in developing the SeatsPlanet app was managing the driver’s profile which curates the details of his/her car as well.
                    </p>
                    <p className="text-white">
                      Moreover, a systematic mechanism was required to let the users accept whom they would be picking up on their way by enabling the reservation system.
                    </p>
                  </div>
                </Col>
                <Col lg={6}>
                  <StaticImage loading="lazy" src={Seatsplanetleft} alt="Seatsplanetleft" width={393} height={536} />
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section pb-0" style={{ backgroundColor: `#0a98a8` }}>
            <Container className="py-5 mt-lg-5">
              <div className="pt-4 text-center">
                <h2 className="mb-4 text-white title-border-sm text-center h3">
                  User experience
                </h2>
                <p className="opacity-75 text-white lead">
                  To make things easy for the people, we were required to come with an effective solution so as to enhance their experience. Therefore, we came up with the GPS based design to let users know and book the car effortlessly and let them manage their bookings at ease.
                </p>
              </div>
            </Container>
            <div className="text-center mt-5">
              <StaticImage loading="lazy" src={Seatsplanetuser} alt="Seatsplanetuser" className="m-auto" width={1920} height={690} />
            </div>
          </section>
          <section className="section">
            <Container className="py-5 mt-lg-5">
              <div className="text-center pb-5">
                <h2 className="mb-4 title-border-sm text-center h3">
                  App design
                </h2>
                <p>
                  Right from making the wireframes till the concluding app design we consistently infused innovation in the process of creating an app. post wireframing we worked for enhancing the realistic appearance of this ride sharing app.
                </p>
              </div>
              <div className="text-center">
                <div className="position-relative">
                  <StaticImage loading="lazy" src={Seatsplanetscrol1} alt="Seatsplanetscroll" className="m-auto position-absolute" width={800} height={433} />
                  <StaticImage loading="lazy" src={Seatsplanetscrol2} alt="Seatsplanetscrol2" className="m-auto position-absolute" width={800} height={433} />
                  <StaticImage loading="lazy" src={Seatsplanetscrol3} alt="Seatsplanetscrol2" className="m-auto position-absolute" width={800} height={433} />
                  <StaticImage loading="lazy" src={Seatsplanetscrol4} alt="Seatsplanetscrol2" className="m-auto" width={800} height={433} />
                </div>
              </div>
            </Container>
          </section>
          <section className="section" style={{ backgroundColor: `#63c6d6` }}>
            <Container className="py-5">
              <div className="pb-4 text-center">
                <h2 className="mb-4 title-border-sm text-center h3 text-white">
                  Interactive feature
                </h2>
                <p className="text-white">
                  For effective solution to the daily problem of the world, SeatsPlanet app comes with multi-faceted interactive feature such that users can post ride, search the same, and book it. this keeps the pick-up cars and carpoolers in constant touch.
                </p>
              </div>
              <Row className="align-items-center g-5" xs={1} md={1} lg={2}>
                <Col className="text-center">
                  <Image loading="lazy" className="lazyload" src={Seatsplanetpostride} alt="Seatsplanetpostride" width={295} height={610} />
                </Col>
                <Col>
                  <h3 className="mb-4 text-white title-border-sm">
                    Post ride
                  </h3>
                  <p className="text-white">If you want to be a driver and want to earn some extra money, then post your trip details. Anybody interested to join you, will contact you through your profile details.</p>
                </Col>
              </Row>
            </Container>
            <Container className="py-5">
              <Row className="align-items-center g-5" xs={1} md={1} lg={2}>
                <Col className="text-center order-lg-2">
                  <div className="d-flex align-items-center">
                    <StaticImage loading="lazy" src={Seatsplanetpostridevector} alt="Seatsplanetpostridevector" width={278} height={409} />
                    <Image loading="lazy" className="lazyload" src={Seatsplanetpostridesearch} alt="Seatsplanetpostridesearch" width={295} height={610} />
                  </div>
                </Col>
                <Col className="order-lg-1">
                  <h3 className="mb-4 text-white title-border-sm">
                    Search ride
                  </h3>
                  <p className="text-white">If you are a passenger and want to book taxi, then search for your relevant trip. If decided to join, then just book your seat and be in touch with the driver.</p>
                </Col>
              </Row>
            </Container>
            <Container className="py-5">
              <Row className="align-items-center g-5" xs={1} md={1} lg={2}>
                <Col className="text-center">
                  <div className="d-flex align-items-center">
                    <Image loading="lazy" className="lazyload" src={Seatsplanetpostbookridegif} alt="Seatsplanetpostbookridegif" width={295} height={610} />
                    <StaticImage loading="lazy" src={Seatsplanetpostbookride} alt="Seatsplanetpostbookride" width={236} height={354} />
                  </div>
                </Col>
                <Col>
                  <h3 className="mb-4 text-white title-border-sm">
                    Book ride
                  </h3>
                  <p className="opacity-75 text-white lead">Be a passenger, search from the available shared rides, and book taxi, after calculating the estimated time and distance. Also, see user reviews and ratings before short listing your option.</p>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section pb-0 border-end border" >
            <Container className="pt-5">
              <Row className="align-items-center g-5" xs={1} md={1} lg={2}>
                <Col>
                  <h3 className="mb-4 title-border-sm">
                    Agenda
                  </h3>
                  <p>It provides a historical listing of all the rides posted, searches, seat reservations, and notifications till the present date.</p>
                </Col>
                <Col className="text-center">
                  <StaticImage loading="lazy" src={Seatsplanetagenda} alt="Seatsplanetagenda" width={382} height={861} />
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section 0bg-light pb-0 border-end border">
            <Container className="pt-5">
              <Row className="align-items-center g-5" xs={1} md={1} lg={2}>
                <Col className="order-lg-2">
                  <h3 className="mb-4 title-border-sm">
                    My earning
                  </h3>
                  <p>All the payments are made online so once the driver marks a trip ‘complete’ the money is deposited in his synched account. There is also a dashboard which provides details regarding the earned money, and also it reflects the withdrawals towards your bank account. It gets easy to manage your entire carpool budgeting within the SeatsPanet app itself.</p>
                </Col>
                <Col className="text-center order-lg-1">
                  <StaticImage loading="lazy" src={Seatsplanetearning} alt="Seatsplanetearning" width={395} height={863} />
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section">
            <Container className="py-5">
              <div className="pt-4 text-center">
                <h2 className="mb-4 title-border-sm text-center h3">
                  An overall glimpse
                </h2>
                <p className="opacity-75 lead">
                  From user’s profile to car profile, to even GPS navigation and private chat window – we have integrated every possible thing to make tasks easy for the users. while at the same time our design standards ensure lucidity and reliability.
                </p>
              </div>
              <div className="text-center mt-5">
                <StaticImage loading="lazy" src={Seatsplanetdiver} alt="Seatsplanetdiver" className="m-auto" width={1099} height={715} />
              </div>
            </Container>
          </section>
          <section className="section" style={{ backgroundColor: `#37bad1` }}>
            <Container className="py-5">
              <div className="mb-5 pb-1">
                <h2 className="mb-4 text-white title-border-sm text-center h3">
                  Technology Stack
                </h2>
              </div>
              <Row className="g-4" xs={1} md={2} lg={3}>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Language</h3>
                    <p className="mb-3"><strong>Swift</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }} >Database</h3>
                    <p className="mb-3"><strong>CoreData</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Networking</h3>
                    <p className="mb-3"><strong>AFNetworking, SDWebImage</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Language</h3>
                    <p className="mb-3"><strong>Android</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Database</h3>
                    <p className="mb-3"><strong>SQLite</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Networking</h3>
                    <p className="mb-3"><strong>Volley, Glide image caching library</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Chat</h3>
                    <p className="mb-3"><strong>QuickBlox</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Social</h3>
                    <p className="mb-3"><strong>Facebook SDK</strong></p>
                  </div>
                </Col>
                <Col>
                  <div className="techstack">
                    <h3 className="h4 mt-3" style={{ color: "#00c7d4" }}>Payment gateway</h3>
                    <p className="mb-3"><strong>PayPal</strong></p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section" style={{ backgroundColor: `#0a98a8` }}>
            <Container className="py-5 text-center">
              <StaticImage loading="lazy" src={Seatsplanettechnology} alt="Seatsplanettechnology" className="m-auto" width={943} height={333} />
            </Container>
          </section>
        </div>
        <CaseStudy
          sectionClass="bg-light"
        />
      </Layout>
    </>
  );
};

export default SeatsplanettravelappPage;

export const PortfSingleData = graphql`
  query Seatsplanettravelapp ($slug: String!) {
    portfolioJson (slug: { eq: $slug }) {
      seo {
        title
        description
        socialImage {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`